<template>
    <div class="bespoke-marketing-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Bespoke Marketing from Epwin Studio
                </div>
                <div class="logo">
                </div>
            </div>
            <div class="box-1">
                <h1>Bespoke Marketing at its best</h1>
                <p>
                    When you join Epwin Window Systems, you’ll have access to a range of marketing
                    services to help market your business. But that’s just the start. We provide a wide range
                    of marketing support items designed to help you sell more. Our <a href="/marketing/brandhub360" class="txt-primary" target="_blank">Brandhub360 portal</a>
                    gives you access to a wide range of professionally designed brochures, point of sale
                    materials, advertising collateral and more.
                </p>
                <p>
                    Alongside the standard material available via <a href="/marketing/brandhub360" class="txt-primary" target="_blank">Brandhub360</a>, we can also help you
                    with bespoke marketing campaigns specifically designed for your business to support
                    your sales processes.
                </p>
            </div>
            <div class="overlapping-image">
                <img src="/images/bespoke-marketing-page-image-1.png">
            </div>
            <div class="box-2">
                <p>
                    Our inhouse design studio provides Epwin Window Systems’ customers with the
                    reassurance they will be working with experienced graphic designers who understand
                    your products, your markets and produce high quality results. Whether it’s a flyer for a
                    special offer, a leaflet that introduces the company or a complete retail or trade brochure
                    that promotes a particular range of products or services, our in-house studio is on hand
                    to help.
                </p>
                <p>
                    We can also provide additional hands-on marketing support. We can help you
                    understand the best ways to reach your target markets or put together a full marketing
                    campaign. If you want to focus on online activity, we can help you prepare a digital
                    strategy. And there are exclusive hands-on workshops to help you sell the benefits of
                    replacement windows, rather than being forced to compete on price.
                </p>
                <div class="buttons">
                    <div class="button">
                        <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                            Make Enquiry
                        </a>
                    </div>
                    <div class="button">
                        <a href="http://www.epwinstudio.co.uk/" target="_blank" class="btn-primary-outline _lg" @click="partnerLinkClicked()">
                            Submit a Brief
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Bespoke Marketing Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I am interested in working on a Bespoke Marketing project with Epwin',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 2,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Bespoke marketing enquiry',
                'value': 'Bespoke marketing enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Epwin Studio`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Epwin Studio partner link clicked',
          'value': 'Epwin Studio partner link clicked',
        });
      },
    },
};
</script>
